import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetojyotibacab() {



  const cardData = {




keyword: "Pune to Jyotiba Cab",

headingDescription: "Garud Cab Service provides comfortable and reliable Pune to Jyotiba Cab Service for devotees, families, senior citizens, couples, and groups planning a spiritual journey to Jyotiba Temple near Kolhapur. We offer chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for one-way journeys, round trips, Darshan visits, and customized religious travel plans. With experienced drivers, clean and well-maintained vehicles, flexible pickup locations across Pune, spacious luggage facilities, transparent pricing, and 24/7 customer assistance, we make the journey convenient and comfortable. Travelers can also combine Jyotiba Temple with Kolhapur, Panhala, Narsobawadi, and other nearby religious and heritage destinations for a complete pilgrimage itinerary.",

topPlaces: [
  {
    title: "Jyotiba Temple",
    description: "Jyotiba Temple is a revered hilltop pilgrimage destination near Kolhapur and is dedicated to Lord Jyotiba. Situated on a scenic hill, the temple attracts devotees throughout the year and is especially vibrant during major religious occasions. Travelers from Pune can book a private cab for comfortable Darshan, flexible travel timings, and convenient door-to-door transportation."
  },
  {
    title: "Kolhapur",
    description: "Kolhapur is a prominent cultural and religious city in Maharashtra known for the Mahalaxmi Temple, traditional cuisine, handicrafts, and historic attractions. Travelers visiting Jyotiba can conveniently include Kolhapur in their itinerary for sightseeing and religious visits. Garud Cab Service provides spacious vehicles for families and groups traveling from Pune."
  },
  {
    title: "Mahalaxmi Temple",
    description: "Mahalaxmi Temple is one of the most important religious landmarks in Kolhapur and is dedicated to Goddess Mahalaxmi, also known as Ambabai. Devotees from different parts of Maharashtra visit the temple throughout the year. Travelers booking a Pune to Jyotiba cab can combine Jyotiba Darshan with a visit to this famous temple."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is a historic hill fort near Kolhapur known for its impressive fortifications, scenic surroundings, and connection with Maratha history. The elevated location provides beautiful views of the surrounding countryside. Families and groups traveling from Pune can include Panhala in a customized Jyotiba and Kolhapur sightseeing itinerary."
  },
  {
    title: "Rankala Lake",
    description: "Rankala Lake is a popular attraction in Kolhapur offering peaceful surroundings, walking areas, scenic views, and a relaxing atmosphere. It is a convenient sightseeing stop for families and visitors exploring the city after temple Darshan. A private cab makes it easy to combine Rankala Lake with Jyotiba Temple and other Kolhapur attractions."
  },
  {
    title: "Narsobawadi",
    description: "Narsobawadi is an important pilgrimage destination in Maharashtra associated with Lord Dattatreya and Shri Narasimha Saraswati. Located near the Krishna River, the town attracts devotees seeking a peaceful spiritual experience. Travelers from Pune can include Narsobawadi in an extended religious journey along with Jyotiba and Kolhapur."
  },
  {
    title: "Audumbar",
    description: "Audumbar is a well-known spiritual destination associated with Shri Narasimha Saraswati and the worship of Lord Dattatreya. The peaceful riverside surroundings make it a popular destination for devotees and spiritual travelers. Garud Cab Service can arrange comfortable transportation from Pune for passengers planning a multi-destination pilgrimage."
  },
  {
    title: "Gaganbawda",
    description: "Gaganbawda is a scenic region in the Western Ghats known for lush greenery, mountain landscapes, waterfalls, and peaceful natural surroundings. It offers travelers an opportunity to combine religious travel with nature exploration. Visitors traveling to Jyotiba from Pune can add Gaganbawda to a longer Kolhapur-region road trip."
  },
  {
    title: "Khidrapur",
    description: "Khidrapur is known for the ancient Kopeshwar Temple, an architectural and religious landmark situated near the Krishna River. The temple features intricate stone carvings and traditional craftsmanship, making it interesting for both devotees and heritage enthusiasts. It can be included in a customized religious sightseeing route from Pune."
  },
  {
    title: "Amba Ghat",
    description: "Amba Ghat is a scenic mountain pass in the Sahyadri ranges offering winding roads, green hills, valleys, and beautiful views during the journey toward the Kolhapur region. It is particularly attractive during the monsoon season. Travelers can combine the scenic route with Jyotiba and other nearby destinations when planning a private cab trip from Pune."
  }
],




"services": [
{
"name": "Pune to Kolhapur Cab Service",
"description": "Book Pune to Kolhapur Cab Service for comfortable, reliable, and convenient intercity transportation with professional chauffeurs and well-maintained AC vehicles. Choose from Sedan, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, and premium cab options for family trips, business travel, sightseeing, temple visits, pilgrimage journeys, one-way drops, and round-trip travel."
},
{
"name": "Pune to Kolhapur Cab Booking",
"description": "Make Pune to Kolhapur Cab Booking for a private and comfortable journey with scheduled pickup and direct drop facilities. Select a suitable vehicle according to passenger count, luggage requirements, travel date, and comfort preferences, with options ranging from economical sedans to spacious Ertiga, Innova, Innova Crysta, Kia Carens, and SUV cabs."
},
{
"name": "Pune to Balumama Cab Service",
"description": "Reserve Pune to Balumama Cab Service for a convenient pilgrimage journey with experienced chauffeurs and comfortable AC vehicles. The service is suitable for devotees, families, and groups traveling from Pune to Balumama temple destinations with flexible pickup arrangements and vehicle options including Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV."
},
{
"name": "Pune to Admapur Cab",
"description": "Book Pune to Admapur Cab for comfortable and private travel to the Balumama temple area with professional chauffeur service and well-maintained AC vehicles. Choose a suitable car for individual travelers, families, devotees, and groups planning one-way, return, or scheduled pilgrimage journeys from Pune."
},
{
"name": "Pune to Kolhapur Laxmi Temple Cab",
"description": "Hire Pune to Kolhapur Laxmi Temple Cab for a convenient pilgrimage and temple visit from Pune to the renowned Mahalaxmi Temple in Kolhapur. Enjoy private AC transportation, experienced drivers, flexible pickup, spacious seating, and suitable vehicle choices for families, devotees, senior citizens, and groups."
},
{
"name": "Pune to Jyotiba Cab Package",
"description": "Book Pune to Jyotiba Cab Package for a comfortable pilgrimage trip to Jyotiba Temple with flexible travel arrangements and professional chauffeur service. Choose Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles for individual travelers, families, devotees, and groups planning a one-day or customized temple visit."
},
{
"name": "Pune to Jyotiba Innova Cab Package",
"description": "Reserve Pune to Jyotiba Innova Cab Package for a spacious and comfortable pilgrimage journey from Pune to Jyotiba Temple. The Innova provides generous seating, luggage space, AC comfort, and professional chauffeur service, making it suitable for families and groups traveling for darshan and sightseeing."
},
{
"name": "Pune to Jyotiba Innova Crysta Cab",
"description": "Hire Pune to Jyotiba Innova Crysta Cab for a premium and relaxed temple journey with spacious interiors, comfortable seating, ample luggage capacity, and professional chauffeur service. It is a suitable choice for families, senior passengers, devotees, and groups seeking enhanced comfort during their pilgrimage travel."
},
{
"name": "Pune to Jyotiba Ertiga Cab",
"description": "Book Pune to Jyotiba Ertiga Cab for practical and comfortable group transportation from Pune to Jyotiba Temple. Ertiga offers spacious seating, useful luggage capacity, AC interiors, and chauffeur-driven travel, making it suitable for families and small groups planning darshan and return journeys."
},
{
"name": "Pune to Jyotiba Sedan Cab Booking",
"description": "Make Pune to Jyotiba Sedan Cab Booking for an economical and comfortable private journey to Jyotiba Temple. A clean AC sedan with a professional chauffeur provides convenient door-to-door transportation for couples, small families, individual devotees, and passengers planning a scheduled pilgrimage trip."
},
{
"name": "Pimpri Chinchwad to Jyotiba Temple Cab",
"description": "Reserve Pimpri Chinchwad to Jyotiba Temple Cab for direct and comfortable pilgrimage transportation with convenient pickup from Pimpri Chinchwad. Choose from Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV vehicles according to your group size, luggage needs, and preferred comfort level."
},
{
"name": "Pimpri Chinchwad to Jyotiba Cab",
"description": "Book Pimpri Chinchwad to Jyotiba Cab for a private and convenient journey to Jyotiba Temple with experienced chauffeurs and well-maintained AC vehicles. The service is suitable for devotees, families, senior citizens, and groups requiring one-way or round-trip transportation."
},
{
"name": "Pune to Kolhapur Gagangiri Cab",
"description": "Choose Pune to Kolhapur Gagangiri Cab for comfortable pilgrimage and spiritual travel with professional chauffeurs and private AC transportation. Flexible pickup arrangements and multiple vehicle categories make the service suitable for families, devotees, and groups traveling to Gagangiri Maharaj destinations around Kolhapur."
},
{
"name": "Pune to Jyotiba Kia Carens Cab",
"description": "Hire Pune to Jyotiba Kia Carens Cab for spacious and comfortable pilgrimage travel with premium seating, AC interiors, useful luggage space, and professional chauffeur service. Kia Carens is suitable for families and groups looking for a relaxed journey from Pune to Jyotiba Temple."
},
{
"name": "Pune to Jyotiba Temple Kolhapur Cab",
"description": "Book Pune to Jyotiba Temple Kolhapur Cab for a convenient private journey from Pune to Jyotiba Temple in Kolhapur. Enjoy direct pickup, experienced chauffeurs, clean AC vehicles, and flexible Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for devotees and families."
},
{
"name": "Pune to Jyotiba Mahalaxmi Cab",
"description": "Reserve Pune to Jyotiba Mahalaxmi Cab for a convenient pilgrimage covering Jyotiba Temple and Mahalaxmi Temple in Kolhapur. Comfortable chauffeur-driven vehicles, flexible pickup arrangements, and suitable options for families, devotees, senior citizens, and groups make the journey convenient for darshan and sightseeing."
},
{
"name": "Pune Jyotiba Mahalaxmi Darshan Package",
"description": "Book Pune Jyotiba Mahalaxmi Darshan Package for a planned pilgrimage covering the important Jyotiba and Mahalaxmi temples in Kolhapur. Travel comfortably in a private AC cab with an experienced chauffeur and select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to group size and itinerary."
},
{
"name": "Pune to Kolhapur Mahalaxmi Jyotiba Cab",
"description": "Hire Pune to Kolhapur Mahalaxmi Jyotiba Cab for convenient temple darshan at Mahalaxmi and Jyotiba Temple. Enjoy private door-to-door transportation, comfortable AC interiors, professional drivers, and flexible travel schedules suitable for families, devotees, senior passengers, and pilgrimage groups."
},
{
"name": "Pune Jyotiba Mahalaxmi Panhala Tour",
"description": "Plan Pune Jyotiba Mahalaxmi Panhala Tour for a convenient combination of pilgrimage and sightseeing around Kolhapur. Visit Jyotiba Temple, Mahalaxmi Temple, and Panhala Fort in a comfortable chauffeur-driven cab with flexible itinerary options and vehicle choices suitable for families and groups."
},
{
"name": "Pune to Jyotiba and Panhala Fort Cab",
"description": "Book Pune to Jyotiba and Panhala Fort Cab for a comfortable pilgrimage and sightseeing journey covering Jyotiba Temple and historic Panhala Fort. Enjoy private AC transportation, professional chauffeur service, convenient pickup, and spacious vehicle options for families, devotees, tourists, and groups."
},
{
"name": "Pune to Kolhapur Jyotiba Tour Package",
"description": "Reserve Pune to Kolhapur Jyotiba Tour Package for a planned temple visit with comfortable chauffeur-driven transportation from Pune. The package can be arranged with Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV vehicles according to passenger count, luggage requirements, and preferred travel duration."
},
{
"name": "Pune Kolhapur Jyotiba One-Day Package",
"description": "Book Pune Kolhapur Jyotiba One-Day Package for a convenient same-day pilgrimage trip from Pune to Jyotiba Temple and back. Enjoy scheduled pickup, comfortable AC travel, experienced chauffeurs, and suitable vehicle choices for families, devotees, couples, and small groups."
},
{
"name": "Pune to Mahalaxmi Temple and Jyotiba Cab",
"description": "Choose Pune to Mahalaxmi Temple and Jyotiba Cab for a convenient Kolhapur pilgrimage covering two important religious destinations. Private chauffeur-driven transportation provides comfortable AC travel, flexible pickup and drop arrangements, and suitable vehicles for families, devotees, senior citizens, and groups."
},
{
"name": "Pune Jyotiba Panhala Two-Day Package",
"description": "Reserve Pune Jyotiba Panhala Two-Day Package for a relaxed pilgrimage and sightseeing journey with enough time to visit Jyotiba Temple and explore Panhala Fort. Enjoy private AC transportation, comfortable overnight travel arrangements, experienced chauffeurs, and vehicle choices suitable for families and groups."
},
{
"name": "Pune to Kolhapur Pilgrimage Cab",
"description": "Book Pune to Kolhapur Pilgrimage Cab for comfortable religious travel to important temples and spiritual destinations in and around Kolhapur. Flexible routes, private AC vehicles, professional chauffeurs, and multiple seating options make the service suitable for devotees, families, senior citizens, and pilgrimage groups."
},
{
"name": "Pune Kolhapur Mahalaxmi Jyotiba Darshan",
"description": "Plan Pune Kolhapur Mahalaxmi Jyotiba Darshan with a private chauffeur-driven cab for convenient temple visits. Travel comfortably between Pune and Kolhapur while visiting Mahalaxmi and Jyotiba temples with flexible schedules, spacious vehicles, and suitable options for families, devotees, and groups."
},
{
"name": "Pune Narsobawadi Jyotiba Mahalaxmi Tour",
"description": "Book Pune Narsobawadi Jyotiba Mahalaxmi Tour for a comprehensive pilgrimage covering Narsobawadi, Jyotiba Temple, and Mahalaxmi Temple. Enjoy comfortable private transportation with an experienced chauffeur and select Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, or SUV according to your group size and travel plan."
},
{
"name": "Pune Jyotiba Mahalaxmi Narsobawadi Cab",
"description": "Hire Pune Jyotiba Mahalaxmi Narsobawadi Cab for a convenient multi-destination pilgrimage journey covering important religious places in Maharashtra. Flexible itinerary planning, private AC transportation, professional chauffeurs, and spacious vehicle options make the trip comfortable for families, devotees, and groups."
},
{
"name": "Pune Kolhapur Jyotiba Khidrapur Package",
"description": "Reserve Pune Kolhapur Jyotiba Khidrapur Package for a comfortable pilgrimage and temple sightseeing journey covering Jyotiba and Khidrapur along with Kolhapur destinations. Travel in a private AC cab with professional chauffeur service and choose a suitable vehicle for families, devotees, and groups."
},
{
"name": "Pune to Jyotiba Kaneri Math Cab Package",
"description": "Book Pune to Jyotiba Kaneri Math Cab Package for a convenient spiritual journey covering Jyotiba Temple and Kaneri Math. Enjoy private chauffeur-driven transportation, clean AC vehicles, flexible pickup arrangements, and suitable Sedan, Ertiga, Innova, Innova Crysta, Kia Carens, and SUV options for pilgrimage groups and families."
}
],
"tableData": [
["Pune to Kolhapur Cab Service", "Pune to Kolhapur Cab Booking"],
["Pune to Balumama Cab Service", "Pune to Admapur Cab"],
["Pune to Kolhapur Laxmi Temple Cab", "Pune to Jyotiba Cab Package"],
["Pune to Jyotiba Innova Cab Package", "Pune to Jyotiba Innova Crysta Cab"],
["Pune to Jyotiba Ertiga Cab", "Pune to Jyotiba Sedan Cab Booking"],
["Pimpri Chinchwad to Jyotiba Temple Cab", "Pimpri Chinchwad to Jyotiba Cab"],
["Pune to Kolhapur Gagangiri Cab", "Pune to Jyotiba Kia Carens Cab"],
["Pune to Jyotiba Temple Kolhapur Cab", "Pune to Jyotiba Mahalaxmi Cab"],
["Pune Jyotiba Mahalaxmi Darshan Package", "Pune to Kolhapur Mahalaxmi Jyotiba Cab"],
["Pune Jyotiba Mahalaxmi Panhala Tour", "Pune to Jyotiba and Panhala Fort Cab"],
["Pune to Kolhapur Jyotiba Tour Package", "Pune Kolhapur Jyotiba One-Day Package"],
["Pune to Mahalaxmi Temple and Jyotiba Cab", "Pune Jyotiba Panhala Two-Day Package"],
["Pune to Kolhapur Pilgrimage Cab", "Pune Kolhapur Mahalaxmi Jyotiba Darshan"],
["Pune Narsobawadi Jyotiba Mahalaxmi Tour", "Pune Jyotiba Mahalaxmi Narsobawadi Cab"],
["Pune Kolhapur Jyotiba Khidrapur Package", "Pune to Jyotiba Kaneri Math Cab Package"]
]
,



whychoose: [
  {
    WhyChooseheading: "Pune to Jyotiba Cab for a Comfortable Temple Journey",
    WhyChoosedescription: "Garud Cab Service offers private Pune to Jyotiba cab services for devotees, families, senior citizens, and groups planning a peaceful pilgrimage to Shri Jyotiba Temple near Kolhapur with convenient travel arrangements."
  },
  {
    WhyChooseheading: "Private Cab for Flexible Darshan Plans",
    WhyChoosedescription: "Travel in a dedicated cab and plan your departure, temple visit, rest breaks, and return journey according to your preferred schedule instead of depending on fixed public transport timings."
  },
  {
    WhyChooseheading: "Suitable for Families & Senior Devotees",
    WhyChoosedescription: "A private vehicle is a convenient option for families travelling with elderly devotees, allowing comfortable seating, planned breaks, easy boarding, and a more relaxed pilgrimage experience."
  },
  {
    WhyChooseheading: "One-Way & Round-Trip Options",
    WhyChoosedescription: "Choose a one-way cab if Jyotiba is your final destination, or book a round-trip arrangement when you want to return to Pune after completing your darshan and local visits."
  },
  {
    WhyChooseheading: "Pickup from Your Preferred Pune Location",
    WhyChoosedescription: "Start your religious journey from your home, hotel, office, residential society, or another convenient pickup point in Pune with a cab arranged around your travel requirements."
  },
  {
    WhyChooseheading: "Combine Jyotiba with Kolhapur Sightseeing",
    WhyChoosedescription: "If your schedule permits, you can include Kolhapur attractions and additional religious destinations in your itinerary, creating a more complete pilgrimage and sightseeing experience."
  },
  {
    WhyChooseheading: "Comfortable Vehicles for Devotee Groups",
    WhyChoosedescription: "Garud Cab Service can arrange a suitable vehicle based on the number of passengers, luggage, and comfort requirements, making group travel easier to coordinate."
  },
  {
    WhyChooseheading: "Arrange Your Jyotiba Trip with Garud",
    WhyChoosedescription: "Share your Pune pickup location, travel date, number of devotees, preferred vehicle, and one-way or return requirement to arrange suitable transportation for your Jyotiba pilgrimage."
  }
]


};


const faqData = [
  {
    question: "Does Garud Cab Service provide Pune to Jyotiba Cab Service?",
    answer: "Yes, Garud Cab Service provides Pune to Jyotiba cabs for temple darshan, religious journeys, family trips, senior citizens, and devotee groups."
  },
  {
    question: "Can I book a one-way cab from Pune to Jyotiba?",
    answer: "Yes, one-way cab arrangements are available for passengers who need direct transportation from Pune to the Jyotiba temple area."
  },
  {
    question: "Can I book a return cab from Jyotiba to Pune?",
    answer: "Yes, return and round-trip cab arrangements can be planned according to your darshan schedule and preferred return timing."
  },
  {
    question: "Is Pune to Jyotiba cab suitable for senior citizens?",
    answer: "Yes, private cab travel can be a convenient choice for senior devotees because it allows flexible breaks and a less rushed travel schedule."
  },
  {
    question: "Can families book a private cab for Jyotiba Darshan?",
    answer: "Yes, families can arrange a suitable vehicle based on their group size, luggage, and comfort requirements."
  },
  {
    question: "Can I get pickup from my home in Pune?",
    answer: "Yes, pickup can be arranged from your home, hotel, office, residential society, or another preferred location in Pune."
  },
  {
    question: "Can I include Kolhapur sightseeing in the trip?",
    answer: "Yes, Kolhapur sightseeing and additional religious places can be discussed while preparing the itinerary, depending on your available travel time."
  },
  {
    question: "Can groups of devotees travel together?",
    answer: "Yes, devotee groups can select a suitable vehicle according to their passenger count, luggage, and desired comfort level."
  },
  {
    question: "Can I plan Jyotiba Darshan as a same-day trip?",
    answer: "Yes, a same-day travel plan can be discussed according to your departure time, darshan schedule, return requirement, and overall itinerary."
  },
  {
    question: "How can I book a Pune to Jyotiba Cab?",
    answer: "Share your Pune pickup point, travel date, number of passengers, preferred vehicle, and one-way or round-trip requirement with Garud Cab Service to arrange your Jyotiba cab."
  }
];


const testimonials = [
  {
    id: 1,
    name: "Mr. Amol Kadam",
    feedback: "Our family travelled from Pune to Jyotiba for darshan and booked a private cab. The pickup was convenient and the journey was comfortable for our elderly family members.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Manisha Patil",
    feedback: "We planned a Jyotiba visit along with some Kolhapur sightseeing. The private cab gave us the flexibility to manage the temple visit and other stops according to our schedule.",
    rating: 5
  }
];





  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Pune to Mumbai Airport Cab",
      link: "pune-to-mumbai-airport-cab-service",
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Pune to Outstation Cabs",
      link: "Pune-to-Outstation-Cabs",
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Pune to Mahabaleshwar Cab",
      link: "pune-to-mahabaleshwar-cab-service",
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Pune to Lonavala Cab",
      link: "pune-to-lonavala-cab-service",
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Pune to Matheran Cabs",
      link: "pune-to-matheran-cab-service",
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Pune to 5 Jyotirlinga Darshan Cab",
      link: "pune-to-5-jyotirlinga-cab-service",
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Pune to Bhimashankar Cab",
      link: "pune-to-bhimashankar-cab-service",
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Pune to Aurangabad Cab Service",
      link: "Pune-to-Aurangabad-Cab-Service",
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Pune to Nashik Cab Service",
      link: "Pune-to-Nashik-Cab-Service",
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Pune to Kolhapur Cab Service",
      link: "Pune-to-Kolhapur-Cab-Service",
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Pune to Alibaug Cab",
      link: "Pune-to-Alibaug-Cab",
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/13.jpg",
      text: "Goa to Pune Cabs",
      link: "Goa-to-Pune-Cabs",
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Innova Crysta Cab in Pune",
      link: "Innova-Crysta-Cab-in-Pune",
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Ertiga On Rent in Pune",
      link: "Ertiga-On-Rent-in-Pune",
    },
    {
      place: "/images/keyword/16.jpg",
      text: "Pune to Ashtavinayak Cabs",
      link: "pune-to-ashtavinayak-cab-service",
    },
    {
      place: "/images/keyword/17.jpg",
      text: "Pune to Goa Cabs",
      link: "Pune-to-Goa-Cabs",
    },
    {
      place: "/images/keyword/18.jpg",
      text: "Pune to Jyotirlinga Darshan Package",
      link: "Pune-to-Jyotirlinga-Darshan-Package",
    },
    {
      place: "/images/keyword/19.jpg",
      text: "Pune to Akkalkot Cabs",
      link: "Pune-to-Akkalkot-Cabs",
    },
    {
      place: "/images/keyword/20.jpg",
      text: "Pune to Pandharpur Cab",
      link: "Pune-to-Pandharpur-Cab",
    },
    {
      place: "/images/keyword/21.jpg",
      text: "Pune to Grishneshwar Jyotirlinga Cab",
      link: "Pune-to-Grishneshwar-Jyotirlinga-Cab",
    },
    {
      place: "/images/keyword/22.jpg",
      text: "Pune to Mumbai Cabs",
      link: "pune-to-mumbai-cab-service",
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Alibag Cab",
      link: "Pune-to-Alibag-Cab",
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Goa Cab Service",
      link: "Pune-to-Goa-Cab-Service",
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Innova Crysta On Rent in Pune",
      link: "Innova-Crysta-On-Rent-in-Pune",
    },

  ];





const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Jyotiba Cab",
  "image": "https://garudcabs.com/assets/images/pune-to-jyotiba-cab.webp",
  "description": "Book Pune to Jyotiba Cab with Garud Cab for a comfortable and convenient pilgrimage journey. Get reliable cab booking and tour package services from Pune to Jyotiba, Kolhapur, Admapur, Balumama Temple, and Laxmi Temple with Innova and other spacious vehicle options for families and groups.",
  "brand": {
    "@type": "Brand",
    "name": "Garud Cab"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "7934"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://garudcabs.com/pune-to-jyotiba-cab"
  }
};








  return (
    <div>


<Helmet>
  <title>Pune to Jyotiba Cab | Kolhapur & Temple Taxi Package | +91 9970007784</title>

  <meta
    name="description"
    content="Book Pune to Jyotiba Cab with Garud Cab for comfortable pilgrimage travel. Get Pune to Kolhapur cab booking, Balumama and Admapur cab services, Laxmi Temple transfers, and Jyotiba Innova cab packages for families and groups."
  />

  <meta
    name="keywords"
    content="Pune to Kolhapur cab service, Pune to Kolhapur cab booking, Pune to Balumama cab service, Pune to Admapur Cab, Pune to Kolhapur Laxmi Temple cab, Pune to Jyotiba cab package, Pune to Jyotiba Innova cab package"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>




      <section className="page-banner">
        <div className="page-banner-container">
          <h2>
            {cardData.keyword}
          </h2>
        </div>
      </section>








      <section>
        <div className="container-fluid p-0" >
          <div className="row container-fluid px-md-2">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/29.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Garud Cabs Services: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>





              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div className="service-card" key={index}>
                    <div className="service-content">
                      <h4>{service.name}</h4>
                      <span className="line"></span>
                      <p>{service.description}</p>
                    </div>

                    <div className="service-icon">
                      <i className="fas fa-arrow-right"></i>
                    </div>
                  </div>
                ))}
              </div>

              <div className="keyword-grid">
                {cardData.tableData.flat().map((keyword, index) => (
                  <div key={index} className="keyword-item">
                    <span className="keyword-bullet">-</span>
                    {keyword}
                  </div>
                ))}
              </div>



              <div id="why-choose-section" className="why-choose-section">

                <h2 className="section-title text-dark">
                  Why Choose <span>Garud Cabs Services</span>
                </h2>

                <div className="bento-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div className="bento-card" key={index}>

                      <div className="bento-number">
                        {String(index + 1).padStart(2, "0")}
                      </div>

                      <h4>{item.WhyChooseheading}</h4>

                      <p>{item.WhyChoosedescription}</p>

                    </div>
                  ))}
                </div>

              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Garud Cabs Services </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fas fa-phone-alt"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919970007784 " className="pc-call">+91 9970007784 </a>
                    </div>
                    <div className="pc-list">
                      <a href="tel:+919970353709 " className="pc-call">+91 9970353709 </a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919970007784 "
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919970007784 " className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-envelope"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@garudcabs.com" className="pc-email">
                      booking@garudcabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="fa-solid fa-location-dot"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Garud Cabs Services</strong><br />
                      Office No.101 Anand Heights
                      Chandan Nagar, Kharadi, Pune,
                      Maharashtra, India-  411014




                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetojyotibacab;